export const instantiateWasm = async (
  response: Response,
  importObject?: WebAssembly.Imports
) => {
  if (typeof WebAssembly.instantiateStreaming === 'function') {
    return WebAssembly.instantiateStreaming(response, importObject);
  } else {
    return response
      .arrayBuffer()
      .then(bytes => WebAssembly.instantiate(bytes, importObject));
  }
};
